<template>
  <b-container class="bv-example-row">
    <!-- home page slider -->
    <!-- <b-row>
      <b-col lg="12" sm="12" style="margin-bottom: 3px">
        <b-carousel
          id="carousel-fade"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators
          img-width="1024"
          img-height="480"
        >
          <b-carousel-slide
            caption="First slide"
            img-src="https://picsum.photos/1024/480/?image=10"
          ></b-carousel-slide>
          <b-carousel-slide
            caption="Second Slide"
            img-src="https://picsum.photos/1024/480/?image=12"
          ></b-carousel-slide>
          <b-carousel-slide
            caption="Third Slide"
            img-src="https://picsum.photos/1024/480/?image=22"
          ></b-carousel-slide>
        </b-carousel>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col lg="4" sm="6" v-for="item in list" :key="item.id" style="margin-bottom: 6px;">
        <b-card
          no-body
          style="max-width: 20rem;"
          :img-src="item.image_url"
          :img-alt="item.name"
          img-top
        >
          <b-card-body class="exp-product">
            <b-card-title>
              {{item.name.replace('- GT1', '').replace('- GT2', '').replace('Transparent ', '')}}
            </b-card-title>
            <b-card-sub-title class="mb-1">
              Style: {{item.name.includes('GT1') ? 'GT1': 'GT2'}}, Color: {{item.name.includes('Transparent') ? 'Transparent': 'Solid'}}
            </b-card-sub-title>
            <h3>
              ${{item.price}}
            </h3>
            <b-button @click="onAddToCart(item)" style="margin-bottom: 3px;" block class="my-btn" variant="danger">
              <i class="ti-shopping-cart"></i>
              Add to Cart
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import list from '../config/products.json'
export default {
  // this for A/B testing home page version
  data () {
    return {
      list
    }
  },
  methods: {
    async onAddToCart (item) {
      let cartSize = window.Snipcart.store.getState().cart.items.items.length + 1
      let metadata = {
        cartSize,
        type: 'button',
        source: 'welcomePage'
      }
      let properties = {...metadata, item}
      window.analytics.track('Add to Cart', properties)
      window.gtag('event', 'select_content', {
        'content_type': 'product',
        'items': [item]
      })
      try {
        let addResponse = await window.Snipcart.api.cart.items.add({
          id: item.id,
          name: item.name,
          price: item.price,
          url: item.url,
          image: item.image,
          quantity: 1
        })
        console.log(addResponse)
      } catch (error) {
        console.log(error)
      }
    },
    onBuyNow (item) {

    }
  }
}
</script>
<style scoped>
.exp-product {
  padding-bottom: 0 !important;
}
@media (max-width: 360px){
  .col-sm-6 {
    max-width: 50%;
  }
  .exp-product h4 {
    font-size: 9px;
  }
  .exp-product h6 {
    font-size: 9px;
  }
  .my-btn {
    font-size: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeDisplay.vue